import { Component, Input } from '@angular/core';



export class InfotipComponent {
   infotipText: string;
   infotipId: string = '';

   handlePropagation(e) {
    e.stopPropagation();
    e.preventDefault();
   }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'infotip',
  templateUrl: './infotip.component.html',
  styleUrls: ['./infotip.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'infotipText': [{ type: Input },],
'infotipId': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
